import { styled } from '@mui/material';

export const AvatarGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '& > *:not(:first-of-type)': {
    marginLeft: '-20px',

    [theme.breakpoints.down('md')]: {
      marginLeft: '-16px',
    },
  },
}));
